import { useTranslation } from "react-i18next";
import { platform } from "./index";

export function useAppTranslation() {
  const { t, i18n } = useTranslation();
  const { t: tBrand } = useTranslation("brand");

  function tb(key: string, options?: Record<string, unknown>): string {
    return tBrand(key, options) as string;
  }

  return { t, tb, i18n, platform };
}
